import { Injectable } from '@angular/core';
import { AngularFirestore, QueryFn } from '@angular/fire/compat/firestore';
import { firstValueFrom } from 'rxjs';

import UniqueEntityID from '../../../core/domain/unique_entity_id';
import { SizeChartForChildren } from '../domain/size_chart_for_children';

export interface SizeChartForChildrenSchema {
  age: number;
  femaleMinus3: number;
  femaleMinus2: number;
  female: number;
  femalePlus2: number;
  femalePlus3: number;
  maleMinus3: number;
  maleMinus2: number;
  male: number;
  malePlus2: number;
  malePlus3: number;
}

@Injectable()
export class SizeChartForChildrenRepository {
  constructor(private firestore: AngularFirestore) {
    // Nada
  }

  private collection(queryFn?: QueryFn) {
    return this.firestore.collection<SizeChartForChildrenSchema>(
      'size_chart_for_children',
      queryFn,
    );
  }

  fromSchema(
    schema: SizeChartForChildrenSchema,
    id: string,
  ): SizeChartForChildren {
    return SizeChartForChildren.create(
      {
        age: schema.age,
        femaleMinus3: schema.femaleMinus3,
        femaleMinus2: schema.femaleMinus2,
        female: schema.female,
        femalePlus2: schema.femalePlus2,
        femalePlus3: schema.femalePlus3,
        maleMinus3: schema.maleMinus3,
        maleMinus2: schema.maleMinus2,
        male: schema.male,
        malePlus2: schema.malePlus2,
        malePlus3: schema.malePlus3,
      },
      new UniqueEntityID(id),
    );
  }

  async findAll(limit: number): Promise<SizeChartForChildren[]> {
    const snap = await firstValueFrom(
      this.collection((ref) => ref.orderBy('age', 'asc').limit(limit)).get(),
    );
    return snap.docs.map((doc) => this.fromSchema(doc.data(), doc.id));
  }
}
